import { Component, OnInit } from '@angular/core';
import {RemitosService} from '@services/remitos-service';
import {Subscription} from 'rxjs/Subscription';
import {ABMRolesService} from '@services/abm-roles-service';
import {FormControl} from '@angular/forms';
import {SEARCH_TYPE_ACOPIO, SEARCH_TYPE_ACOPIO_NEW_NEGOCIO} from '@services/search-service';
import {Observable} from 'rxjs/Observable';
import {MdDialogRef, MdSnackBar} from '@angular/material';

@Component({
  selector: 'app-acopio-selector-dialog',
  templateUrl: './acopio-selector-dialog.component.html',
  styleUrls: ['./acopio-selector-dialog.component.scss', '../../common/remitos-common-styles.scss']
})
export class AcopioSelectorDialogComponent implements OnInit {

  acopiosSelected: RemitoAcopio[] = [];
  acopiosBase: RemitoAcopio[] = [];

  // autocomplete
  acopiosAll: RemitoAcopio[] = [];
  acopiosFiltered: RemitoAcopio[] = [];
  acopioStateControl: FormControl;


  sub: Subscription[] = [];

  submitLoading = false;

  autorizarOk = false;
  desautorizarOk = false;
  submitErr = false;

  constructor(
    private remitosService: RemitosService,
    private acopiosService: ABMRolesService,
    private dialogRef: MdDialogRef<AcopioSelectorDialogComponent>,
    private snackBar: MdSnackBar,
  ) {
    this.sub.push(
      remitosService.acopiosPermitidos().subscribe(x => {
        if (x && x.length) {
          this.acopiosBase = [...x];
          this.acopiosSelected = [...x];
        }
      })
    );

    this.sub.push(
      acopiosService.getAcopios().subscribe(x => {
        if (x && x.length) {
          this.acopiosAll = x.map(y => ({Nombre: y.AcopioNombre, IdAcopio: y.Id}))
        }
      })
    );

    this.acopioStateControl = new FormControl();

    this.acopioStateControl.valueChanges
      .startWith(null)
      .debounceTime(100)
      .subscribe(res => {
        if (res && res.toString().length > 1) {
          this.acopiosFiltered = this.acopiosAll.filter(x => x.Nombre.toLowerCase().includes(res.toString().toLowerCase()));
        } else {
          this.acopiosFiltered = [];
        }
      })

  }

  ngOnInit() {
  }

  deleteItem(item: RemitoAcopio) {
    this.acopiosSelected = this.acopiosSelected.filter(x => x.IdAcopio !== item.IdAcopio);
  }

  selectAcopio(item: RemitoAcopio) {
    // solo incluir valores no existentes actualmente
    if (this.acopiosSelected.findIndex(x => x.IdAcopio === item.IdAcopio) === -1) {
      this.acopiosSelected.push(item);
    }
  }

  onSubmit() {
    // este servicio se compone de 2 EP: uno que añade y uno que quita valores (yo no lo programe)
    // utilizamos el array base para saber quienes se añadieron y quienes se eliminaron

    const toAdd: RemitoAcopio[] = [];
    // añadidos, valores presentes en el array selected y no en el base
    this.acopiosSelected.forEach(sel => {
      if (this.acopiosBase.findIndex(x => x.IdAcopio === sel.IdAcopio) === -1) {
        toAdd.push(sel);
      }
    });

    const toDelete: RemitoAcopio[] = [];
    // eliminados, valores presentes en el base y no en el selected
    this.acopiosBase.forEach(sel => {
      if (this.acopiosSelected.findIndex(x => x.IdAcopio === sel.IdAcopio) === -1) {
        toDelete.push(sel);
      }
    });

    if (toAdd.length) {
      this.remitosService.autorizarAcopios({AcopiosId: toAdd.map(x => x.IdAcopio)}).subscribe(res => {
        this.autorizarOk = true;
        this.verifySubmit();
      }, error => {
        this.submitErr = true;
        this.verifySubmit();
      });
    } else {
      this.autorizarOk = true;
    }

    if (toDelete.length) {
      this.remitosService.quitarAutorizacion({AcopiosId: toDelete.map(x => x.IdAcopio)}).subscribe(res => {
        this.desautorizarOk = true;
        this.verifySubmit();
      }, error => {
        this.submitErr = true;
        this.verifySubmit();
      });
    } else {
      this.desautorizarOk = true;
    }

  }

  verifySubmit() {
    if (this.submitErr) {
      this.snackBar.open('Ha ocurrido un error procesando la solicitud. Por favor, intente nuevamente.', '', {
        duration: 2000,
        extraClasses: ['agd-warning-snackbar']
      });
    } else if (this.autorizarOk && this.desautorizarOk) {
      this.dialogRef.close(true);
      this.snackBar.open('Acopios actualizados correctamente.', '', {
        duration: 2000,
        extraClasses: ['agd-info-snackbar']
      });
    }
  }

}

export interface RemitoAcopio {
  Nombre: string;
  IdAcopio: number;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/acopio-selector-dialog/acopio-selector-dialog.component.ts